import numeral from "numeral";
export var formatDollars = function (dollars, short) {
    if (short === void 0) { short = false; }
    var isBigNumber = dollars > 999;
    return numeral(dollars)
        .format(short ? (isBigNumber ? "$0.0a" : "$0") : "$0,0")
        .replace(isBigNumber && short ? /\.0/g : "", "")
        .toUpperCase();
};
export var formatCents = function (cents) {
    return numeral(cents).divide(100).format("$0,0.00");
};
export var formatCentsAsDollars = function (cents, short) {
    if (short === void 0) { short = false; }
    return formatDollars(Math.round(cents / 100), short);
};
